import { EnhancedEcommerceService } from './ec-service';
import { Config } from './config.model';

export function init(config: Config)
{
    let ecService = new EnhancedEcommerceService(config);
    ecService.init();
    return ecService;
}